import React from 'react';

function DesktopMainNav({ mainMenu, klassName }) {
  let timeout;
  const stringParameterize = function (str1) {
    return str1.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-');
  };

  const clearActiveMenu = () => {
    const topLevelLinks = document.querySelectorAll('.top-level-link');
    for (const link of topLevelLinks) {
      link.classList.remove('active');
    }
  };

  const handleOnFocus = (event) => {
    clearActiveMenu();
    const currentLink = event.target;
    if (timeout != null) { clearTimeout(timeout); }
    // Store the timeout handle
    // Prevents showing menu too quickly if mouse lingers just a bit
    // Otherwise mega menu flashes in and out
    timeout = setTimeout(() => {
      currentLink.classList.add('active');
    }, 250);
  };

  return (
    <nav className={`main-nav nav-${klassName}`} role="navigation" aria-label="Top Level Navigation">
      <ul className={klassName} role="menubar">
        {Object.keys(mainMenu).map((key) => {
          if (mainMenu[key].children !== null && mainMenu[key].children.length > 0) {
            return (
              <li className="list-item" role="menuitem" key={mainMenu[key].name}>
                <a href={mainMenu[key].url} className={`top-level-link top-level-link--${stringParameterize(mainMenu[key].name)}`}
                   role="button" onFocus={(e) => handleOnFocus(e)}
                >
                  {mainMenu[key].name}
                </a>
                <div className={`mega-menu-wrapper mega-menu--${stringParameterize(mainMenu[key].name)}`}>
                  <div className="page-width inner-menu-wrapper">
                    <ul className="main-submenu" role="menu">
                      {mainMenu[key].children.map((childLink) => (
                        <li role="none" key={childLink.name}>
                          <a
                            className="subnav-link"
                            href={childLink.url}
                            role="menuitem"
                            data-toplevel-link={`top-level-link--${stringParameterize(mainMenu[key].name)}`}
                            data-linkedto={`mega-menu--${stringParameterize(mainMenu[key].name)}`}
                          >
                            {childLink.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li>
            );
          }

          return (
            <li role="none" className="normal-link" key={mainMenu[key].name}>
              <a href={mainMenu[key].url} role="menuitem">
                {mainMenu[key].name}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default DesktopMainNav;
